import { useConfigStore } from "../../Stores/Config";
import { useSessionStore } from "../../Stores/Session";
import { GenericHttpClient } from "./config/http.generic.client";

// Reports opt-in widget-interaction analytics straight to the server. Lives in the
// messenger (Gleap-hosted), so it works for every install without an SDK update.
export class HttpWidgetService extends GenericHttpClient<any> {
  static _instance: HttpWidgetService;
  static getInstance(): HttpWidgetService {
    if (this._instance == null) {
      this._instance = new HttpWidgetService("/v3/shared/widget");
    }
    return this._instance;
  }

  protected injectToken(
    headers: Record<string, string | boolean>,
  ): Record<string, string | boolean> {
    const { session, sdkKey } = useSessionStore.getState();

    if (sdkKey) {
      headers["api-token"] = sdkKey;
    }
    if (session && session.gleapId) {
      headers["gleap-id"] = session.gleapId;
    }
    if (session && session.gleapHash) {
      headers["gleap-hash"] = session.gleapHash;
    }

    return headers;
  }

  async trackEvent(name: string, data?: any): Promise<void> {
    // Gated here so neither call site sends anything unless the project opted in.
    // The server re-checks the flag as well.
    if (!useConfigStore.getState().config?.trackWidgetInteractions) {
      return;
    }

    try {
      await this.post(`${this.path}/track`, {
        events: [{ name, date: new Date().toISOString(), data }],
      });
    } catch {}
  }
}
